import { IApplicationState } from '../types/redux';

export const newbuildingIdSelector = (state: IApplicationState) => {
  return state.newbuilding.id;
};
